import { Flex } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { BsWhatsapp } from "react-icons/bs";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5565999999102"
      target="_blank"
      rel="noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
      }}
    >
      <Flex
        bg={colors.green}
        w="60px"
        h="60px"
        rounded="full"
        justifyContent="center"
        align="center"
        cursor="pointer"
        boxShadow="0 4px 12px rgba(0, 0, 0, 0.3)"
        _hover={{
          transform: "scale(1.1)",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
        }}
        transition="all 0.3s ease"
      >
        <BsWhatsapp size={30} color="white" />
      </Flex>
    </a>
  );
}
